import AddCroppedImage from "./addCroppedImage";

export default AddCroppedImage;
